import script from "./FRAMA.vue?vue&type=script&lang=js"
export * from "./FRAMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__